"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gussago": {
    "7407c021": [{
      "hkey": "173ec166",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "casaglio": [{
      "hkey": "173ec166",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gussago"
    }],
    "cae07baf": [{
      "hkey": "173ec166",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "navezze": [{
      "hkey": "173ec166",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gussago"
    }],
    "61fbae5c": [{
      "hkey": "173ec166",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "sale": [{
      "hkey": "173ec166",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gussago"
    }]
  }
};
exports["default"] = _default;